import { Controller } from "@hotwired/stimulus"
import Plyr from "plyr"

export default class extends Controller {
  static targets = ["audio"]

  connect() {
    this.player = new Plyr(this.audioTarget, {
      controls: ["play", "progress", "current-time", "duration"],
      invertTime: false
    })
  }

  disconnect() {
    this.player?.destroy()
  }
}
